// src/components/PaginationControl.jsx
import React from "react";
import { Box, Button } from "@mui/material";

export default function PaginationControl({
  page,
  totalItems,
  pageSize,
  onPageChange,
  sx,
}) {
  const pageCount = Math.max(1, Math.ceil(totalItems / pageSize));

  // Helper function to handle page change + scroll
  const handlePageChange = (newPage) => {
    // Scroll smoothly to top of the page
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Trigger parent page change callback
    onPageChange(newPage);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mt: 2,
        gap: 1,
        ...sx,
      }}
    >
      <Button
        variant="outlined"
        onClick={() => handlePageChange(page - 1)}
        disabled={page <= 1}
      >
        Previous
      </Button>

      <Button
        variant="outlined"
        onClick={() => handlePageChange(page + 1)}
        disabled={page >= pageCount}
      >
        Next
      </Button>
    </Box>
  );
}
